import { Flex, Group, Paper, Skeleton, Stack, Text } from "@mantine/core";
import { useTrophyCaseData } from "../api/useTrophyCaseData";
import { getBadgeText } from "../utils/getBadgeDetails";
import { formatStartDate } from "../utils/getFormattedDate";
import { TrophyCaseBadges } from "./TrophyCaseBadges";
import classes from "./TrophyCaseCard.module.css";

export function TrophyCaseCard() {
    const { data, isLoading } = useTrophyCaseData();

    const BadgeSkeleton = () => (
        <Stack align="center">
            <Skeleton height={50} width={50} circle />
            <Skeleton height={8} width={50} />
            <Skeleton height={20} width={30} />
        </Stack>
    );
    if (isLoading || !data) {
        return (
            <Paper w="100%" h="25.62rem" p=".875rem" radius="xs" color="dark.7">
                <Stack gap="xs">
                    <Skeleton height={18} width="30%" animate={true} />
                    <Flex gap="sm" justify="space-between">
                        {Array(3)
                            .fill(0)
                            .map((_, i) => (
                                <BadgeSkeleton key={i} />
                            ))}
                    </Flex>
                    <Skeleton height={18} width="30%" mt={20} mb={5} />
                    {Array(5)
                        .fill(0)
                        .map((_, i) => (
                            <Flex key={i} justify="space-between" mb={8}>
                                <Skeleton height={12} width="60%" />
                                <Skeleton height={12} width="20%" />
                            </Flex>
                        ))}
                </Stack>
            </Paper>
        );
    }

    if (!data.challengesHistory || data.challengesHistory.length === 0) {
        return (
            <Paper w="100%" h="5.25rem" color="dark.7">
                <Stack gap="0.875rem" p="0.875rem">
                    <Text fw={700} size="0.75rem" c="dark.0">
                        Trophy case
                    </Text>
                    <Text size="0.75rem" c="dark.2">
                        No badges to show yet. A new challenge will be launching soon!
                    </Text>
                </Stack>
            </Paper>
        );
    }

    return (
        <Paper w="100%" h="25.62rem" p=".875rem" radius="md" color="dark.7">
            <Stack gap="sm">
                <Text fw={700} size="0.75rem" c="dark.0">
                    Trophy case
                </Text>
                <Flex direction={"column"} style={{ overflow: "auto" }} h="23.125rem" gap="sm">
                    <TrophyCaseBadges trophyCaseStats={data.trophyCaseStats} />

                    <Stack pt="0.875rem">
                        <Text fw={700} size="0.75rem">
                            Trophy history
                        </Text>

                        {data.challengesHistory?.map((challenge, index) => (
                            <Group key={index} className={classes.trophyHistoryRow} justify="space-between">
                                <Text size="0.75rem" c="dark.1" fw={400}>
                                    {index + 1}. {getBadgeText(challenge.challengeType)}
                                </Text>
                                <Text size="0.75rem" c="dark.1" fw={400}>
                                    {formatStartDate(challenge.startDate)}
                                </Text>
                            </Group>
                        ))}
                    </Stack>
                </Flex>
            </Stack>
        </Paper>
    );
}
